var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post)?_c('PostDetail',_vm._b({},'PostDetail',_vm.post,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }